<svelte:head>
	<link rel='stylesheet' href='vendor/bootstrap/css/bootstrap.min.css'> 
	<script src="vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
</svelte:head>

<script>
  import LoginForm from './lib/Login.svelte'
</script>

<main>
	<LoginForm />
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}
	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
